import React from 'react';
import './App.scss';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import './components/RandomSmiles.scss';
import {VisitorApp} from "./components/VisitorApp";
import {AdminApp} from "./components/AdminApp";
import {Store} from "./models/Store";

function App() {
    return (
        <Router basename={Store.routerBasename}>
            <div className="App" style={{height: '100%'}}>
                <Switch>
                    <Route path='/admin'><AdminApp></AdminApp></Route>
                    <Route path="/"><VisitorApp></VisitorApp></Route>
                </Switch>
            </div>
        </Router>);
}

export default App;
